import {
  AfterViewInit,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Optional,
  Renderer2,
  Self,
  ViewContainerRef,
} from '@angular/core';
import { FormControl, NgControl } from '@angular/forms';
import { MAT_FORM_FIELD, MatFormField } from '@angular/material/form-field';
// eslint-disable-next-line max-len
import { BorderErrorContainerDirective } from '@shared/components/most-used/form-error/border-error-container.directive';
import { EMPTY, merge, Observable, Subject, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ControlErrorContainerDirective } from './control-error-container.directive';
import { FormErrorComponent } from './form-error-component/form-error.component';
import { customFormErrors, defaultFormErrors, ErrorDictionary } from './form-errors.list';
import { FormEventsDirective } from './form-events.directive';

interface IFormError {
  key: string;
  text: string;
}

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector,max-len
  selector:
  // eslint-disable-next-line @angular-eslint/directive-selector
  //   '[formControlName]:not(.disable-form-error),[formControl]:not(.disable-form-error),[formControlErrors]',
    '[formControlErrors]',
})
export class TMPFormErrorDirective {

  constructor(
  ) {
  }
}
